import { render, staticRenderFns } from "./ui-rich-select.vue?vue&type=template&id=10fb3074&scoped=true&"
import script from "./ui-rich-select.vue?vue&type=script&lang=js&"
export * from "./ui-rich-select.vue?vue&type=script&lang=js&"
import style0 from "./ui-rich-select.vue?vue&type=style&index=0&id=10fb3074&lang=scss&scoped=true&"
import style1 from "./ui-rich-select.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fb3074",
  null
  
)

export default component.exports